import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { createPortal } from "react-dom";
//import videoBackground from "./Assets/Wallpaper.png";
import TopBar from "./TopBar";
import Login from "./Try/Login";
import coinsImg from "./Assets/Coin.jpg.png";
import google from "./Assets/google.jpg";
// import xianhe from "./Assets/logo_black.png";
// import xianheLogo2 from "./Assets/newlogo.png";
// import xianheLogo2 from "./Assets/logo_goldenlf.png";
// import xianhe from "./Assets/logo_lotus_fairy.jpg";
// import xianheLogo2 from "./Assets/xianheLogo2.png";
import serviceBorder from "./Assets/serviceBorder.png";
import { FaApple } from "react-icons/fa";
import { signInWithGooglePopup } from "../utils/firebase.utils";
import { getAuth, OAuthProvider, signInWithPopup } from "firebase/auth";
import XianheModal from "./Visitor/NewUser";
import Visitor from "./Visitor/VisitorPage";
import ElementFinder from "./Visitor/ElementFinder";
import AboutPage from "./AboutPage";

import Footer from "./Try/Footer.jsx";
import ChatLoginPrompt from "./ChatBot/ChatLoginPrompt";
// import animatedFairy from "./Assets/animatedFairy.mp4";
// import animatedFairy from "./Assets/Viedo.mp4";
// import animatedFairy from "./Assets/Viedo1.mp4";

import { useTranslation } from 'react-i18next';
import globeIcon from "./Assets/globe.png";
import { fetchLanguages } from '../i18n'; // Add this import
import { syncProfileLanguageFromGetProfile } from "../utils/profileLanguageSync";

import AmuletShowcase from "./AmuletShowcase";
//import masterBackground from "./Assets/master_image_bg.png";
// import both desktop & mobile background videos (choose at runtime)
// import videoBackgroundDesktop from "./Assets/bgMaster.mp4";
import masterBackground from "./Assets/master2.jpg";
import fairyImage from "./Assets/fairyImage.png";
import bigStar from "./Assets/bigStar.png";
import backgroundStars from "./Assets/backgroundStars.png";
import videoBackgroundDesktop from "./Assets/bgVideoMaster1.mp4";
import videoBackgroundMobile from "./Assets/bgMasterMobile.mp4";
//import introVideo from "./Assets/introvideo.mp4";
import introVideo from "./Assets/Xianhe New Assets/mainpage/mainpage-video.mp4";

import amulet1 from "./Assets/amulet.png";
import amulet2 from "./Assets/amulet.png";
import amulet3 from "./Assets/amulet.png";
import amulet4 from "./Assets/amulet.png";
import amulet5 from "./Assets/amulet.png";
import amulet6 from "./Assets/amulet.png";
import amulet7 from "./Assets/amulet.png";
import amulet8 from "./Assets/amulet.png";
import amulet9 from "./Assets/amulet.png";
import amulet10 from "./Assets/amulet.png";
import amulet11 from "./Assets/amulet.png";
import OurServices from "./OurServices.jsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import image1 from "./Assets/Questions/mountain.png";
import image2 from "./Assets/Questions/soil.png";
import image3 from "./Assets/Questions/sun.png";
import image4 from "./Assets/Questions/candle_flame.png";
import image5 from "./Assets/Questions/Axe.png";
import image6 from "./Assets/Questions/jewellery.png";
import image7 from "./Assets/Questions/The_tree.png";
import image8 from "./Assets/Questions/The_Flower.png";
import image9 from "./Assets/Questions/Ocean.png";
import image10 from "./Assets/Questions/rain_water.png";
import zodiac1 from "./Assets/Zodiac/dog.png";
import zodiac2 from "./Assets/Zodiac/dragon.png";
import zodiac3 from "./Assets/Zodiac/goat.png";
import zodiac4 from "./Assets/Zodiac/horse.png";
import zodiac5 from "./Assets/Zodiac/monkey.png";
import zodiac6 from "./Assets/Zodiac/ox.png";
import zodiac7 from "./Assets/Zodiac/pig.png";
import zodiac8 from "./Assets/Zodiac/rabbit.png";
import zodiac9 from "./Assets/Zodiac/rat.png";
import zodiac10 from "./Assets/Zodiac/rooster.png";
import zodiac11 from "./Assets/Zodiac/snake.png";
import zodiac12 from "./Assets/Zodiac/tiger.png";
import "./HeLanding.css";
import heroSky from "./Assets/he-landing/hero-sky.png";
import amuBg from "./Assets/he-landing/amu-bg.png";
import aboutBg from "./Assets/he-landing/about-bg.png";
import aboutBanner from "./Assets/he-landing/about-banner.png";
import filmPoster from "./Assets/he-landing/film-poster.png";
import arrowRight from "./Assets/he-landing/arrow-right.svg";
import amuFallback1 from "./Assets/he-landing/amu-1.png";
import amuFallback2 from "./Assets/he-landing/amu-2.png";
import amuFallbackFeatured from "./Assets/he-landing/amu-featured.png";
import amuFallback4 from "./Assets/he-landing/amu-4.png";
import amuFallback5 from "./Assets/he-landing/amu-5.png";

// Shown in the A-MU carousel until products load; index 2 is the featured slot
const AMU_FALLBACK_IMAGES = [amuFallback1, amuFallback2, amuFallbackFeatured, amuFallback4, amuFallback5];


function MainPage() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [name, setName] = useState("");
  const [showSignInModal, setShowSignInModal] = useState(false);
  const [showEmailSignInModal, setShowEmailSignInModal] = useState(false);
  const [showCollectAmuletLoginModal, setShowCollectAmuletLoginModal] = useState(false);
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [isModal, setIsModal] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", message: "" });
  // videoRef removed; using static image for the right-side artwork
  const location = useLocation();
  const navigate = useNavigate();
  const userID = localStorage.getItem("userID");

  // If another page set openLoginPanel flag, open login panel on mount, or
  // straight away when the chat button asks while this page is showing
  useEffect(() => {
    const openFromFlag = () => {
      try {
        const openFlag = localStorage.getItem('openLoginPanel');
        if (openFlag === 'true') {
          setIsLoginPanelOpen(true);
          localStorage.removeItem('openLoginPanel');
        }
      } catch (e) {}
    };
    openFromFlag();
    window.addEventListener('xianhe:open-login', openFromFlag);
    return () => window.removeEventListener('xianhe:open-login', openFromFlag);
  }, []);

  // Cart & gems state (used by TopBar dropdown)
  const [cartItemCount, setCartItemCount] = useState(0);
  const [coins, setCoins] = useState(0);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isLoginPanelOpen, setIsLoginPanelOpen] = useState(false);
  const dropdownRef = useRef(null);


  const [showElementFinderModal, setShowElementFinderModal] = useState(false);
  const headingRef = useRef(null);
  // Ref that wraps the heading + subheadings + button we want the modal to cover
  const elementRegionRef = useRef(null);
  const [headingWidth, setHeadingWidth] = useState(null);

  // Measured bounding rect in viewport coordinates for the element region
  const [elementRect, setElementRect] = useState(null);

  const [selectedMonth, setSelectedMonth] = useState("5"); // May (1-based)
  const [selectedDay, setSelectedDay] = useState("21");
  const [selectedYear, setSelectedYear] = useState("2000");
  const [elementFinderResult, setElementFinderResult] = useState(null);
  const [elementFinderResult_DO_NOT_SHOW, setElementFinderResult_DO_NOT_SHOW] = useState(null);
  const [showElementResult, setShowElementResult] = useState(false);
  const [zodiacDescriptions, setZodiacDescriptions] = useState({});

  const [zodiacName, setZodiacName] = useState("");
  const [zodiacSign, setZodiacSign] = useState("");
  const [showZodiacTooltip, setShowZodiacTooltip] = useState(false);
  const [zodiacName2, setZodiacName2] = useState("");
  const [zodiacSign2, setZodiacSign2] = useState("");
  const [showZodiacTooltip2, setShowZodiacTooltip2] = useState(false);

  const [siteContent, setSiteContent] = useState({});

  const [showAppointmentsDropdown, setShowAppointmentsDropdown] = useState(false);
  const [showDestinyDropdown, setShowDestinyDropdown] = useState(false);

  const handleAppointmentsMouseEnter = () => setShowAppointmentsDropdown(true);
  const handleAppointmentsMouseLeave = () => setShowAppointmentsDropdown(false);
  const handleDestinyMouseEnter = () => setShowDestinyDropdown(true);
  const handleDestinyMouseLeave = () => setShowDestinyDropdown(false);

  const { t, i18n } = useTranslation();
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem('language') || 'en'
  );
  const [availableLanguages, setAvailableLanguages] = useState([]); // Add this

  // Derive the backend LangId from the currently selected language code.
  // This prevents mismatches where UI language is English but API content is fetched in Bahasa (or vice versa).
  const effectiveLanguageId = useMemo(() => {
    const normalizedCode = (selectedLanguage || 'en').toLowerCase();

    const matched = availableLanguages.find((lang) => {
      const detail = (lang.LookupDetail || '').toString();
      const langCode = detail.match(/^(\S+)/)?.[1]?.toLowerCase() || '';
      return langCode === normalizedCode;
    });

    const matchedId = matched?.Id ?? matched?.id;
    if (typeof matchedId === 'number' && Number.isFinite(matchedId)) return String(matchedId);
    if (typeof matchedId === 'string' && matchedId.trim()) return matchedId.trim();

    // Fallback mapping (based on API language data)
    // - 2224: English (EN)
    // - 2225: Bahasa (ID)
    // - 2226: Chinese (ZH-CN)
    return normalizedCode === 'en' ? '2224' : normalizedCode === 'id' ? '2225' : normalizedCode === 'cn' ? '2226' : '2224';
  }, [availableLanguages, selectedLanguage]);

  // Keep localStorage in sync so other pages/components that still read `languageId` don't drift.
  useEffect(() => {
    if (effectiveLanguageId) {
      localStorage.setItem('languageId', effectiveLanguageId);
    }
  }, [effectiveLanguageId]);

  useEffect(() => {
    fetchLanguages().then(languages => {
      console.log('Fetched languages:', languages); // Debug line
      setAvailableLanguages(languages);
    });
  }, []);

  // 4. Add the updateUserLanguage function (place after other handler functions)
  const updateUserLanguage = async (langId, langDesc) => {
    try {
      console.log('updateUserLanguage called with:', langId, langDesc);
      const userId = localStorage.getItem('userID');
      console.log('Retrieved userId:', userId);
      
      if (!userId) {
        console.warn('No userId found in localStorage');
        return;
      }

      const response = await fetch('https://xianhefairy.com/LotusFairy_API/api/User/LanguageUpdate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ID: parseInt(userId),
          LANG_ID: langId,
          LANG_DESC: langDesc
        })
      });

      console.log('Response status:', response.status);
      if (!response.ok) {
        console.error('Failed to update user language preference');
      } else {
        console.log('User language preference updated successfully');
      }
    } catch (error) {
      console.error('Error updating user language:', error);
    }
  };

  // Fetch all site content and store by Code
  useEffect(() => {
    const languageId = effectiveLanguageId;
    console.log('Fetching site content with languageId:', languageId); // Debug log
    
    // Fetch content for both codes
    const codes = ['I2E57', '4X9HT', 'EC8V2', 'ECFQE'];
    const fetchPromises = codes.map(code => 
      fetch(`https://xianhefairy.com/LotusFairy_API/api/SiteContent/GetSiteContent?Code=${code}&LangId=${languageId}`)
        .then(res => {
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          return res.json();
        })
    );

    Promise.all(fetchPromises)
      .then(results => {
        console.log('Site content data received:', results); // Debug log
        
        // Map by Code for easy access
        const contentMap = {};
        results.forEach(data => {
          if (Array.isArray(data)) {
            data.forEach(item => {
              if (item.Code && item.Description && item.Title) {
                contentMap[item.Code] = {
                  Description: item.Description,
                  Title: item.Title
                };
              }
            });
          }
        });
        console.log('Content map created:', contentMap); // Debug log
        setSiteContent(contentMap);
      })
      .catch(err => {
        console.error("Failed to fetch site content:", err);
      });
  }, [effectiveLanguageId]); // Refetch when language changes

  const amuSectionTitle = siteContent["EC8V2"]?.Title || "Crafted to stay with you, everyday";
  const amuSectionDescriptionRaw = siteContent["EC8V2"]?.Description || "Each A-MU is thoughtfully designed with symbolic elements to support different aspects of daily life from protection and clarity to emotional balance and personal growth.<br><br>Get your daily A-MU, and explore extended options designed for every stage of your journey.";
  const [amuSectionDescriptionLine1, amuSectionDescriptionLine2] = useMemo(() => {
    const lines = amuSectionDescriptionRaw
      .split(/<br\s*\/?>/i)
      .map((line) => line.trim())
      .filter(Boolean);

    return [lines[0] || "", lines.slice(1).join(" ") || ""];
  }, [amuSectionDescriptionRaw]);

  // The API title uses non-breaking spaces, which stop it wrapping on phones
  const rootsSectionTitle = (siteContent["ECFQE"]?.Title || "Ancient Roots. Modern You.").replace(/ /g, " ").trim();
  const rootsSectionDescriptionRaw = siteContent["ECFQE"]?.Description || "Master SiewLi has spent over forty years walking the path of spiritual guidance and XianHe is her bridge between that ancient wisdom and the life you're living today. She built this for modern seekers like you: people who are curious, open, and ready for guidance that actually means something.<br><br>Forty years of spiritual guidance shaped one clear vision: wisdom should be for everyone. Master SiewLi created XianHe to break down the barriers between ancient knowledge and modern life. No gatekeeping. No mystery. Just real guidance for real people, ready to take the next step.";
  const [rootsSectionDescriptionLine1, rootsSectionSubheading, rootsSectionDescriptionLine2] = useMemo(() => {
    const lines = rootsSectionDescriptionRaw
      .split(/<br\s*\/?>/i)
      .map((line) => line.replace(/\u00A0/g, ' ').trim())
      .filter(Boolean);

    if (lines.length >= 3) {
      return [lines[0] || "", lines[1] || "", lines.slice(2).join(" ") || ""];
    }

    // Common API shape: "highlight line<br><br>body line".
    if (lines.length === 2) {
      return ["", lines[0] || "", lines[1] || ""];
    }

    return [lines[0] || "", "", ""];
  }, [rootsSectionDescriptionRaw]);
  const rootsSectionParagraphs = [rootsSectionDescriptionLine1, rootsSectionDescriptionLine2].filter(Boolean);


  // const zodiacDescriptions = {
  //   "Rat": "You’re outgoing, sharp and adaptable. You connect easily with others and learn new skills fast. You notice details, stay focused and bring warmth to everything you do. Your curiosity, drive and positivity help you balance structure with vision.",
  //   "Ox": "You’re thoughtful, diligent and principled. You work steadily toward your goals through focus and determination. Honest and responsible with a caring side, you value loyalty, tradition and doing things the right way from start to finish.",
  //   "Tiger": "You are a brave, ambitious leader who loves taking on challenges and exploring new paths. Honest and reliable and determined, you go after your goals with focus and a positive mindset.",
  //   "Rabbit": "You’re thoughtful, kind and compassionate. With a natural charm that helps you connect with others and turn conflicts into friendships. Family-oriented and graceful, you appreciate beauty and harmony. You are creative, a warm and welcoming person.",
  //   "Dragon": "Like a dragon, you are full of strength and energy. Unstoppable when you go after something you want. Ambitious and driven, you are a talented perfectionist who isn’t afraid to take the lead.",
  //   "Snake": "You are strong, energetic and unstoppable when you set your sights on something. Ambitious and talented, you have a perfectionist streak and are not afraid to step up and take charge.",
  //   "Horse": "You are lively and passionate. With a romantic spirit, with a strong sense of justice and a wide circle of friends. Independent and decisive, you dive into new experiences with confidence, style and determination.",
  //   "Goat": "You’re thoughtful and detail-oriented, valuing sincerity, compassion and kindness which makes you approachable and well-liked. Beneath your graceful, social side is a curious. Hardworking and determined spirit that drives you forward with generosity and focus.",
  //   "Monkey": "You’re a confident, versatile go-getter who thrives on challenges, competition and leadership. Quick to learn and eager to shine, you combine intelligence, charm and boldness to achieve your goals and inspire those around you.",
  //   "Rooster": "You’re intelligent, witty and outspoken. Unafraid to stand out, call out injustice or embrace new trends with confidence. Sociable yet disciplined, you balance charm and competitiveness with a strong sense of responsibility and high standards.",
  //   "Dog": "You’re honest, dependable and principled. Guided by strong morals and a deep sense of justice in everything you do. Compassionate and yet determined, you combine loyalty, intuition and leadership with dedication to the people you care about.",
  //   "Pig": "You’re generous, kind-hearted and loyal. With a strong sense of justice, sincerity that earns lasting friendships. Optimistic and romantic, you stay content, tolerant and unfazed by small conflicts or criticism."
  // };
  // Fetch zodiac descriptions based on language
  useEffect(() => {
    const languageId = effectiveLanguageId;
    
    fetch(`https://xianhefairy.com/LotusFairy_API/api/SiteContent/GetZodiacDetail?LangId=${languageId}`)
      .then(res => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
      })
      .then(data => {
        if (Array.isArray(data)) {
          const descriptionsMap = {};
          data.forEach(item => {
            if (item.Animal) {
              descriptionsMap[item.Animal] = {
                greetings: item.Greetings || '',
                description: item.Description || '',
                symbol: item.Symbol || '',
                zodiac: item.Zodiac || ''
              };
            }
          });
          setZodiacDescriptions(descriptionsMap);
        }
      })
      .catch(err => {
        console.error("Failed to fetch zodiac descriptions:", err);
      });
  }, [effectiveLanguageId]);

  const zodiacMappings = [
    {
      title: "The Dog",
      stem: "DOG",
      image: zodiac1,
    },
    {
      title: "The Dragon",
      stem: "DRAGON",
      image: zodiac2,
    },
    {
      title: "The Goat",
      stem: "GOAT",
      image: zodiac3,
    },
    {
      title: "The Horse",
      stem: "HORSE",
      image: zodiac4,
    },
    {
      title: "The Axe",
      stem: "MONKEY",
      image: zodiac5,
    },
    {
      title: "The Ox",
      stem: "OX",
      image: zodiac6,
    },
    {
      title: "The Pig",
      stem: "PIG",
      image: zodiac7,
    },
    {
      title: "The Rabbit",
      stem: "RABBIT",
      image: zodiac8,
    },
    {
      title: "The Rat",
      stem: "RAT",
      image: zodiac9,
    },
    {
      title: "The Rooster",
      stem: "ROOSTER",
      image: zodiac10,
    },
    {
      title: "The Snake",
      stem: "SNAKE",
      image: zodiac11,
    },
    {
      title: "The Tiger",
      stem: "TIGER",
      image: zodiac12,
    },
  ];


  // Add the same arrays as ElementFinder
  // const months = [
  //   "January",
  //   "February",
  //   "March",
  //   "April",
  //   "May",
  //   "June",
  //   "July",
  //   "August",
  //   "September",
  //   "October",
  //   "November",
  //   "December",
  // ];
  const months = 
    i18n.language === 'id' 
      ? ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
      : i18n.language === 'cn'
      ? ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
      : [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
  const daysInSelectedMonth = new Date(Number(selectedYear), Number(selectedMonth), 0).getDate();
  const days = Array.from({ length: daysInSelectedMonth }, (_, i) => (i + 1).toString());
  const latestBirthYear = new Date().getFullYear();
  const years = Array.from({ length: latestBirthYear - 1920 + 1 }, (_, i) =>
    (latestBirthYear - i).toString()
  );

  // Keep the day valid when switching to a shorter month (e.g. 31 -> February)
  useEffect(() => {
    if (Number(selectedDay) > daysInSelectedMonth) {
      setSelectedDay(String(daysInSelectedMonth));
    }
  }, [selectedDay, daysInSelectedMonth]);

  // Add the same resultMappings as ElementFinder
  const resultMappings = [
    {
      title: "The Mountain",
      stem: "Mountain  ",
      image: image1, // You'll need to import these images
      strength: "Creative, idealistic, and introspective.",
      weakness: "Sometimes detached from reality and overly sensitive.",
      summary: "You have a deep inner world and a vivid imagination.\nYou thrive in environments that allow for self-expression and creativity.",
    },
    {
      title: "The Soil",
      stem: "Soil      ",
      image: image2,
      strength: "As grounded as a lump of soil on the ground.\nAccommodating peacemaker",
      weakness: "Overly cautious and doubtful lives in a cave, unaware of trends",
      summary: "Can The Soil get his head out of the ground?\n- The Star\nHard on the outside, but soft on the inside, am I talking about an egg or The Soil?\n- The Axe",
    },
    {
      title: "The Sun",
      stem: "Sun       ",
      image: image3,
      strength: "You shine as bright as...the Sun. Of course.\nYou are a shining source of fun and adventures",
      weakness: "Your temper is as explosive as the sun is hot.\nMay be confrontational",
      summary: "Wow is he always on fire!\n- The Tree\nHave I told you how hot you are today? Oh? I said it three times already? But The Sun is hot.\n- The Flower",
    },
    {
      title: "The Candle Flame",
      stem: "Candle Flame      ",
      image: image4,
      strength: "You are a superstar, a money star, good with numbers\nConfident and driven",
      weakness: "Competitive risk-taker\nMay be unstable and anxious",
      summary: "Is that a bird, is that a plane, that's a shooting star!\n- The Soil\nStop blinking, twinkling so much so I can see you clearly!\n- The Sun",
    },
    {
      title: "The Axe",
      stem: "Axe       ",
      image: image5,
      strength: "Decisive, chop chop gotta go.\nHonest and analytical",
      weakness: "Unwilling to bury the hatchet.\nHeart and logic as cold as steel.",
      summary: "He chops challenges like he chops my wood!\n- The Tree\nHe always looks like he has an axe to grind.\n- The Mountain",
    },
    {
      title: "The Jewellery",
      image: image6,
      stem: "Jewellery     ",
      strength: "Sharpest knife in the kitchen!\nCuts straight to the point",
      weakness: "Can be very direct.",
      summary: "They say metal reflects light, but really, he deflects my point\n- The Sun",
    },
    {
      title: "The Tree",
      image: image7,
      stem: "Large Tree",
      strength: "You provide shelter to all who come to you.\nYou don't judge.",
      weakness: "You are stubbornly rooted.\nYou can't see the forest for the trees.",
      summary: "The Tree is so tall and inspiring! Yet speaks so gentle and soothing\n- The Flower\nWhy are they so greedy for my sunlight?\n- The Sun",
    },
    {
      title: "The Flower",
      image: image8,
      stem: "Flowers   ",
      strength: "You are caring and helpful\nYou are nurturing and empathetic",
      weakness: "Make up my mind? Make up is meant to go on the face.\nWhen the grass is trampled, the flower flees.",
      summary: "Small, pretty and kinda cute!\n- The Tree\nPretty flower? More like petty flower! Hmph!\n- Another Flower",
    },
    {
      title: "The Ocean",
      stem: "Ocean     ",
      image: image9,
      strength: "Something good about rain clouds here.",
      weakness: "Make up my mind? Make up is meant to go on the face.\nWhen the grass is trampled, the flower flees.",
      summary: "Small, pretty and kinda cute!\n- The Tree\nPretty flower? More like petty flower! Hmph!\n- Another Flower",
    },
    {
      title: "The Rain Water",
      stem: "Rain Water     ",
      image: image10,
      strength: "Something good about rain clouds here.",
      weakness: "Make up my mind? Make up is meant to go on the face.\nWhen the grass is trampled, the flower flees.",
      summary: "Small, pretty and kinda cute!\n- The Tree\nPretty flower? More like petty flower! Hmph!\n- Another Flower",
    },
  ];

  // Modify the date selection handler to use the same API call as ElementFinder
  const handleDateSelection = async () => {
    try {
      const languageId = effectiveLanguageId;
      const custID = localStorage.getItem('userID') || '0';
      
      const url = `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStem`;
      
      const requestBody = {
        cYear: parseInt(selectedYear),
        cMonth: parseInt(selectedMonth),
        cDay: parseInt(selectedDay),
        cTime: "08:30",
        CustID: parseInt(custID),
        LangId: parseInt(languageId)
      };

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data from API");
      }

      const data = await response.json();
      console.log("API response data:", data);
      const stemRelation = data[0]?.STEM_RELATION?.trim();
      const zodiacName = data[0]?.ZODIAC?.trim();
      const zodiacSign = data[0]?.ZODIAC_CN?.trim();

      setZodiacName(zodiacName || "");
      setZodiacSign(zodiacSign || "");

      if (!stemRelation) {
        throw new Error("STEM_RELATION is missing or invalid in the API response");
      }

      const result = resultMappings.find((r) => r.stem.trim() === stemRelation);

      if (result) {
        result.apiStemDescription = data[0]?.STEM_DESCRIPTION || "";
        const zodiacDesc = zodiacDescriptions[zodiacName?.toUpperCase()];
        result.apiZodiacDescription = zodiacDesc ? 
          `${zodiacDesc.greetings}<br><br>${zodiacDesc.description}` : 
          data[0]?.ZODIAC_DESCRIPTION || "";
        setElementFinderResult(result);
        setShowElementResult(true);
      } else {
        console.error("No matching result found for STEM_RELATION:", stemRelation);
      }
    } catch (error) {
      console.error("Error fetching element:", error);
      alert("Error finding your element. Please try again.");
    }
  };

  const handleDateSelection2 = async () => {
    try {
      const languageId = effectiveLanguageId;
      const custID = localStorage.getItem('userID') || '0';
      
      const url = `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStem`;
      
      const requestBody = {
        cYear: parseInt(selectedYear),
        cMonth: parseInt(selectedMonth),
        cDay: parseInt(selectedDay),
        cTime: "08:30",
        CustID: parseInt(custID),
        LangId: parseInt(languageId)
      };

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data from API");
      }

      const data = await response.json();
      console.log("API response data:", data);
      const stemRelation = data[0]?.STEM_RELATION?.trim();
      const zodiacName = data[0]?.ZODIAC?.trim();
      const zodiacSign = data[0]?.ZODIAC_CN?.trim();

      setZodiacName2(zodiacName || "");
      setZodiacSign2(zodiacSign || "");

      if (!stemRelation) {
        throw new Error("STEM_RELATION is missing or invalid in the API response");
      }

      const result = resultMappings.find((r) => r.stem.trim() === stemRelation);

      if (result) {
        result.apiStemDescription = data[0]?.STEM_DESCRIPTION || "";
        const zodiacDesc = zodiacDescriptions[zodiacName?.toUpperCase()];
        result.apiZodiacDescription = zodiacDesc ? 
          `${zodiacDesc.greetings}<br><br>${zodiacDesc.description}` : 
          data[0]?.ZODIAC_DESCRIPTION || "";
        setElementFinderResult_DO_NOT_SHOW(result);
        setShowElementResult(true);
      } else {
        console.error("No matching result found for STEM_RELATION:", stemRelation);
      }
    } catch (error) {
      console.error("Error fetching element:", error);
      alert("Error finding your element. Please try again.");
    }
  };

  // New function to handle "Find Your Destiny" button click
  const handleFindYourDestiny = async () => {
    setShowZodiacTooltip(false); // Reset read more button
    try {
      // First, try to find the element based on selected date
      await handleDateSelection();
      // Then open the ElementFinder modal for the full experience
      //setShowElementFinderModal(true);
    } catch (error) {
      // If element finding fails, still show the modal
      //setShowElementFinderModal(true);
    }
  };

  const handleFindYourDestiny2 = async () => {
    setShowZodiacTooltip2(false); // Reset read more button
    try {
      // First, try to find the element based on selected date
      await handleDateSelection2();
      // Then open the ElementFinder modal for the full experience
      //setShowElementFinderModal(true);
    } catch (error) {
      // If element finding fails, still show the modal
      //setShowElementFinderModal(true);
    }
  };

  // LET'S TALK opens the chat; logged-out visitors are asked to log in or
  // sign up first and come back to /chat afterwards
  const [showChatLoginPrompt, setShowChatLoginPrompt] = useState(false);
  const handleLetsTalk = () => {
    if (localStorage.getItem("isLoggedIn") === "true" && localStorage.getItem("userID")) {
      navigate("/chat");
    } else {
      setShowChatLoginPrompt(true);
    }
  };

  const isElementResultOpen = Boolean(elementFinderResult || elementFinderResult_DO_NOT_SHOW);


  // Measure the element region's bounding rect and save it. Called when modal opens
  // and on resize/scroll to keep it in sync.
  const measureElementRegion = useCallback(() => {
    const el = elementRegionRef.current || headingRef.current;
    if (!el || typeof el.getBoundingClientRect !== 'function') return;
    const rect = el.getBoundingClientRect();
    setElementRect({ top: rect.top, left: rect.left, width: rect.width, height: rect.height });
  }, []);

  useEffect(() => {
    if (!showElementFinderModal) return;
    // measure initially
    measureElementRegion();
    // re-measure on scroll/resize
    window.addEventListener('resize', measureElementRegion);
    window.addEventListener('scroll', measureElementRegion, true);
    return () => {
      window.removeEventListener('resize', measureElementRegion);
      window.removeEventListener('scroll', measureElementRegion, true);
    };
  }, [showElementFinderModal, measureElementRegion]);

  // Prevent background scroll when modal is open
  useEffect(() => {
    if (showElementFinderModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [showElementFinderModal]);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  //const [currentHighlight, setCurrentHighlight] = useState(0);

  const MOBILE_BREAKPOINT = 852;
  const COMPACT_DESKTOP_MAX_WIDTH = 1500;
  const COMPACT_DESKTOP_MAX_HEIGHT = 900;

  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);
  const [viewportSize, setViewportSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [isCompactDesktop, setIsCompactDesktop] = useState(
    window.innerWidth >= MOBILE_BREAKPOINT &&
      (window.innerWidth <= COMPACT_DESKTOP_MAX_WIDTH || window.innerHeight <= COMPACT_DESKTOP_MAX_HEIGHT)
  );
  useEffect(() => {
    const handleResize = () => {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      setViewportSize({ width: viewportWidth, height: viewportHeight });
      setIsMobile(viewportWidth < MOBILE_BREAKPOINT);
      setIsCompactDesktop(
        viewportWidth >= MOBILE_BREAKPOINT &&
          (viewportWidth <= COMPACT_DESKTOP_MAX_WIDTH || viewportHeight <= COMPACT_DESKTOP_MAX_HEIGHT)
      );
    };

    const measureHeading = () => {
      if (headingRef.current) {
        setHeadingWidth(headingRef.current.offsetWidth);
      }
    };

    // Measure on mount and resize
    measureHeading();
    window.addEventListener('resize', measureHeading);

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener('resize', measureHeading);
    };
  }, [COMPACT_DESKTOP_MAX_HEIGHT, COMPACT_DESKTOP_MAX_WIDTH, MOBILE_BREAKPOINT]);



  // Dynamic amulet slider items (array of objects: { id, image, name, periodCategory })
  // Start empty; products will populate this from the API. No static image fallbacks.
  const [sliderAmulets, setSliderAmulets] = useState([]);

  // Helper to derive product image URL similar to other components (fallback to existing static images if missing)
  const getProductImageUrl = (product) => {
    if (!product) return "";
    if (product.ImageUrl) return product.ImageUrl;
    if (product.ImageProdId && product.ImageFile) {
      return `/static/media/product/${product.ImageProdId.toString().padStart(5, 0)}/${product.ImageFile}`;
    }
    if (product.FILENAME && product.ID)
      return `/static/media/product/${product.ID.toString().padStart(5, 0)}/${product.FILENAME}.png`;
    return "";
  };

  // Fetch products to populate amulet slider dynamically
  useEffect(() => {
    let isCancelled = false;
    fetch(`https://xianhefairy.com/LotusFairy_API/api/member/getProduct?LangId=${effectiveLanguageId}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((fetchedData) => {
        if (!Array.isArray(fetchedData)) return;
        const allProducts = fetchedData.map((item) => {
          // Determine periodCategory from DESC_ENG (Daily/Monthly/Yearly)
          let periodCategory = "";
          if (item.DESC_ENG && typeof item.DESC_ENG === "string") {
            const firstWord = item.DESC_ENG.split(/\s+/)[0].toLowerCase();
            if (firstWord === "daily" || firstWord === "monthly" || firstWord === "yearly") {
              periodCategory = firstWord;
            } else {
              const lowerDesc = item.DESC_ENG.toLowerCase();
              if (lowerDesc.includes("daily")) periodCategory = "daily";
              else if (lowerDesc.includes("monthly")) periodCategory = "monthly";
              else if (lowerDesc.includes("yearly")) periodCategory = "yearly";
            }
          }

          return {
            raw: item,
            id: item.ID || item.Product_ID || Math.random().toString(36).slice(2),
            name: item.DESC_ENG || item.DISPLAY_NAME || item.FILENAME || "Amulet",
            periodCategory,
            image: getProductImageUrl(item),
            category: item.CATEGORY_DESC || "",
          };
        });

        // Filter logic: explicit Amulet category/name or those with a periodCategory tag
        const amuletCandidates = allProducts.filter(
          (p) =>
            (p.category && p.category.toLowerCase().includes("amulet")) ||
            (p.name && p.name.toLowerCase().includes("amulet")) ||
            p.periodCategory
        );

        if (!amuletCandidates.length) return;

        const enriched = amuletCandidates.map((p) => ({
          ...p,
          image: p.image || "",
        }));

        if (!isCancelled) setSliderAmulets(enriched);
      })
      .catch((err) => {
        console.error("Failed to load amulet products:", err);
      });

    return () => { isCancelled = true; };
  }, [effectiveLanguageId]);

  // A-MU slideshow: daily (free) amulets first so the show starts on one.
  // Padded to at least 7 slides so a card wrapping from the far left to the far
  // right moves through the hidden slots instead of sweeping across the row.
  const amuletSlides = useMemo(() => {
    const withImages = sliderAmulets.filter((a) => a.image);
    let slides = withImages.length
      ? [...withImages]
          .sort((a, b) => (b.periodCategory === "daily") - (a.periodCategory === "daily"))
          .map((a) => ({ id: a.id, image: a.image, name: a.name, free: a.periodCategory === "daily" }))
      : [...AMU_FALLBACK_IMAGES.slice(2), ...AMU_FALLBACK_IMAGES.slice(0, 2)].map((image, i) => ({
          id: `fallback-${i}`,
          image,
          name: "A-MU",
          free: i === 0,
        }));
    while (slides.length < 7) slides = slides.concat(slides);
    return slides.map((slide, i) => ({ ...slide, key: `${slide.id}-${i}` }));
  }, [sliderAmulets]);

  const [activeAmulet, setActiveAmulet] = useState(0);
  const [isAmuletPaused, setIsAmuletPaused] = useState(false);
  const amuletTouchX = useRef(null);
  const amuletCount = amuletSlides.length;

  useEffect(() => {
    setActiveAmulet(0);
  }, [amuletCount]);

  // Advance every few seconds; a manual change restarts the wait
  useEffect(() => {
    if (isAmuletPaused || amuletCount < 2) return;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    const timer = setTimeout(() => setActiveAmulet((i) => (i + 1) % amuletCount), 5000);
    return () => clearTimeout(timer);
  }, [activeAmulet, isAmuletPaused, amuletCount]);

  const stepAmulet = (direction) =>
    setActiveAmulet((i) => (i + direction + amuletCount) % amuletCount);

  // Slot name for a slide relative to the active one: centre, near, far or hidden
  const getAmuletSlot = (index) => {
    let offset = (index - activeAmulet + amuletCount) % amuletCount;
    if (offset > amuletCount / 2) offset -= amuletCount;
    const side = offset < 0 ? "left" : "right";
    const distance = Math.abs(offset);
    if (distance === 0) return "center";
    if (distance === 1) return `near-${side}`;
    if (distance === 2) return `far-${side}`;
    return `hidden-${side}`;
  };

  // Pause the sky drift while the hero is off screen
  const heroRef = useRef(null);
  useEffect(() => {
    const hero = heroRef.current;
    if (!hero || !("IntersectionObserver" in window)) return;
    const observer = new IntersectionObserver(
      ([entry]) => hero.classList.toggle("he-scene-paused", !entry.isIntersecting),
      { threshold: 0 }
    );
    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  // Profile dropdown style (matches Tryoutpage pattern)
  const dropdownStyle = useMemo(() => ({
    display: isDropdownVisible ? "block" : "none",
    position: "fixed",
    top: "60px",
    right: isMobile ? "8px" : "150px",
    backgroundColor: "black",
    color: "#DFBD69",
    border: "1px solid #DFBD69",
    minWidth: isMobile ? "200px" : "260px",
    maxWidth: isMobile ? "280px" : "320px",
    boxShadow: "0px 8px 16px 0px rgba(255, 215, 0, 0.25)",
    padding: "10px",
    zIndex: 1200,
    borderRadius: "10px",
    backdropFilter: "blur(4px)",
    WebkitBackdropFilter: "blur(4px)",
    transition: "opacity 0.2s ease, transform 0.2s ease",
    opacity: isDropdownVisible ? 1 : 0,
    transform: isDropdownVisible ? "translateY(0)" : "translateY(-4px)",
    pointerEvents: isDropdownVisible ? "auto" : "none",
    willChange: "opacity, transform",
  }), [isDropdownVisible, isMobile]);

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  };

  const modalStyle2 = {
    backgroundColor: "black",
    padding: "20px",
    borderRadius: "8px",
    minWidth: "300px",
  };

  const inputStyle2 = {
    width: "100%",
    padding: "8px",
    marginBottom: "10px",
  };

  const buttonStyle2 = {
    backgroundColor: "#DFBD69",
    color: "black",
    padding: "10px",
    border: "none",
    borderRadius: "4px",
    width: "100%",
    cursor: "pointer",
  };

  const errorStyle = {
    color: "#dfbd69",
    fontSize: "14px",
    marginBottom: "10px",
  };

  const elementFinderModalStyles = {
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2000,
      padding: isMobile ? "10px" : "20px",
      overflow: "hidden", // Prevent scrolling on overlay
    },
    modalContent: {
      background: "#1f1f1f",
      borderRadius: "16px",
      width: isMobile ? "95vw" : "90vw",
      height: isMobile ? "95vh" : "65vh",
      maxWidth: "1200px",
      maxHeight: "800px",
      position: "relative",
      // Make modal content scrollable on mobile
      overflow: isMobile ? "auto" : "hidden",
      paddingTop: isMobile ? "30px" : "30px", // Reduce top padding for more visible content
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.3)",
      display: "flex",
      flexDirection: "column",
    },
    closeButton: {
      position: "absolute",
      top: isMobile ? "20px" : "15px",
      right: "15px",
      background: "#DFBD69",
      color: "#000",
      border: "none",
      borderRadius: "50%",
      width: "40px",
      height: "40px",
      fontSize: "20px",
      cursor: "pointer",
      zIndex: 2001,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "bold",
    },
  };

  // Animation state for Element Finder modal to allow fade in/out
  const [elementFinderModalMounted, setElementFinderModalMounted] = useState(false);
  const [elementFinderModalOpenAnim, setElementFinderModalOpenAnim] = useState(false);

  // Sync mounting and animation when showElementFinderModal changes
  useEffect(() => {
    let timeoutId;
    if (showElementFinderModal) {
      setElementFinderModalMounted(true);
      // allow next tick for CSS transition to pick up
      timeoutId = setTimeout(() => setElementFinderModalOpenAnim(true), 20);
    } else {
      setElementFinderModalOpenAnim(false);
      // wait for animation to finish then unmount
      timeoutId = setTimeout(() => setElementFinderModalMounted(false), 260);
    }
    return () => clearTimeout(timeoutId);
  }, [showElementFinderModal]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleHomeClick = () => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn !== "true") {
      alert("You need to login first before accessing this page");
      return;
    } else {
      navigate("/main");
    }
    console.log(isLoggedIn);
  };
  const handleChartClick = () => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn !== "true") {
      alert("You need to login first before accessing this page");
      return;
    } else {
      navigate("/chart");
    }
    console.log(isLoggedIn);
  };

  const handleAppointmentClick = () => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn !== "true") {
      alert("You need to login first before accessing this page");
      return;
    } else {
      navigate("/myappointment");
    }
    console.log(isLoggedIn);
  };


  useEffect(() => {
    const checkLogin = () => {
      const loggedIn = localStorage.getItem("isLoggedIn") === "true";
      const roleType = localStorage.getItem("roletype");
      const name = localStorage.getItem("name") || "User";
      const shortenedName =
        name.length > 12 ? name.substring(0, 12) + "..." : name;
      setIsLoggedIn(loggedIn);
      
      // Restore language preference after login
      const savedLanguage = localStorage.getItem('language') || 'en';
      setSelectedLanguage(savedLanguage);
      i18n.changeLanguage(savedLanguage);
      
      if (loggedIn) {
        setName(shortenedName);
        if (roleType === "Master") {
          // Redirect to mainmasters page
          window.location.href = "/mainmasters";
        }
      }
    };
    checkLogin();
  }, [i18n]);

  const handleSignIn = () => {
    setShowSignInModal(true);
  };

  const handleModalClose = () => {
    setShowSignInModal(false);
    setShowEmailSignInModal(false);
  };

  const handleEmailSignInOpen = () => {
    setShowSignInModal(false);
    setShowEmailSignInModal(true);
  };

  const handleCollectAmuletClick = () => {
    const loggedIn = localStorage.getItem("isLoggedIn") === "true";
    if (!loggedIn) {
      setShowCollectAmuletLoginModal(true);
      return;
    }
    navigate("/DigitalCharm");
  };

  // TopBar handlers
  const handleDropdownToggle = () => setIsDropdownVisible(prev => !prev);
  const toggleLoginPanel = () => setIsLoginPanelOpen(prev => !prev);

  const handleLogout = () => {
    try {
      localStorage.removeItem("username");
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("coins");
      localStorage.removeItem("comcoins");
    } catch (e) {}
    setIsLoggedIn(false);
    setName("");
    setCoins(0);
    setCartItemCount(0);
    navigate("/main");
    window.location.reload();
  };

  // Cart count effect
  useEffect(() => {
    const fetchCartCount = async () => {
      try {
        const cartRes = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/Usercart/GetUserCart?CustId=${userID}`
        );
        if (!cartRes.ok) return;
        const cartData = await cartRes.json();
        if (Array.isArray(cartData) && cartData.length > 0) {
          const totalItems = cartData.reduce((sum, item) => sum + (item.Qty || 1), 0);
          setCartItemCount(totalItems);
        } else {
          setCartItemCount(0);
        }
      } catch (error) {
        setCartItemCount(0);
      }
    };
    if (userID && isLoggedIn) {
      fetchCartCount();
      const handleCartUpdate = () => fetchCartCount();
      window.addEventListener('cartUpdated', handleCartUpdate);
      const handleStorage = (e) => { if (e.key === "cartUpdatedAt") fetchCartCount(); };
      window.addEventListener('storage', handleStorage);
      const interval = setInterval(fetchCartCount, 3000);
      return () => {
        window.removeEventListener('cartUpdated', handleCartUpdate);
        window.removeEventListener('storage', handleStorage);
        clearInterval(interval);
      };
    } else {
      setCartItemCount(0);
    }
  }, [userID, isLoggedIn, location.pathname]);

  // Coins effect
  useEffect(() => {
    const fetchCoins = async () => {
      try {
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/booking/getTotal?ID=${userID}`,
          { method: "GET", headers: { "Content-Type": "application/json" } }
        );
        if (!response.ok) return;
        const data = await response.json();
        setCoins(data[0].COINS);
      } catch (error) {}
    };
    if (userID && isLoggedIn) {
      fetchCoins();
      const handleGemsUpdate = () => fetchCoins();
      window.addEventListener('gemsUpdated', handleGemsUpdate);
      return () => window.removeEventListener('gemsUpdated', handleGemsUpdate);
    }
  }, [userID, isLoggedIn]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.closest('[data-myspace-trigger]')) return;
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  const handleGoogleLogin = async () => {
    try {
      // Trigger Google sign-in popup
      const result = await signInWithGooglePopup();

      const name = result.user.displayName;
      const email = result.user.email;
      console.log("User Details:", result);
      console.log("User:", name, email);

      // Check if user account exists by calling the API
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/Booking/getEmailAuth?email=${email}`
      );
      if (!response.ok) {
        throw new Error(`API request failed with status ${response.status}`);
      }

      const apiData = await response.json();
      setPassword(apiData[0].PASSWORD);

      // Check if account exists
      if (apiData.length === 0 || !apiData[0]?.ID) {
        try {
          const response = await fetch(
            "https://xianhefairy.com/LotusFairy_API/api/user/ProfileSaveUpdate?token = xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                ID: "0",
                RefNo: "",
                FName: name,
                LName: "",
                DateOfBirth: "2077-01-01 15:30:45",
                ChineseDateOfBirth: "2077-01-01 15:30:45",
                Gender: "Male",
                Age: "0",
                MobileNo: "0",
                Country: 2143,
                Email: email,
                Password: "098786500",
              }),
            }
          );

          if (!response.ok) {
            throw new Error("Request failed with status " + response.status);
          }
          const result = await response.json();
          if (result) {
            console.log("sucess");
            const url =
              "https://xianhefairy.com/LotusFairy_API/api/Values/SubmitLogin"; // Your API URL
            const data = {
              UserName: email,
              Password: password,
              Token: {
                AccessToken:
                  "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
              },
            };
            try {
              const response = await fetch(url, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
              });

              const result = await response.json();

              // Assuming your API returns a field 'success' for login status
              if (result && result.ID !== null && result.ID !== undefined) {
                // Do NOT store plaintext passwords in localStorage.
                localStorage.setItem("username", result.username);
                localStorage.setItem("userID", result.ID);
                localStorage.setItem("name", result.FullName);
                localStorage.setItem("isLoggedIn", "true");
                localStorage.setItem("roletype", result.Role);
                localStorage.setItem("email", email);
                await syncProfileLanguageFromGetProfile({ userId: result.ID, userName: email });

                // Navigate based on the username
                if (result.Role === "Master") {
                  navigate("/mainmasters");
                } else if (result.Role === "Member") {
                  navigate("/chart");
                  try {
                    const response = await fetch(
                      `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotal?ID=${result.ID}`
                    );
                    if (!response.ok) {
                      throw new Error("Network response was not ok");
                    }
                    const data = await response.json();
                    localStorage.setItem("coins", data[0].COINS);
                  } catch (error) {
                    console.error("Error fetching coins:", error);
                  }

                  try {
                    const response = await fetch(
                      `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotalCommission?ID=${result.ID}`
                    );
                    if (!response.ok) {
                      throw new Error("Network response was not ok");
                    }
                    const data = await response.json();
                    localStorage.setItem("comcoins", data[0].COINS);
                  } catch (error) {
                    console.error("Error fetching coins:", error);
                  }
                  window.location.reload();
                }
              } else {
                setModalContent({
                  title: "Wrong Credentials",
                  message: "Username or password is incorrect.",
                });
                setIsModal(true);
                console.log(result);
              }
            } catch (error) {
              setModalContent({
                title: "Error",
                message: "An error occurred during login. Please try again.",
              });
              setIsModal(true);
              console.error("Login error:", error);
            }
          }
        } catch (error) {
          console.error("Sign-up error:", error);
        }
      } else {
        console.log("Account found:", apiData[0]);
        const pass = apiData[0]?.PASSWORD;
        const url =
          "https://xianhefairy.com/LotusFairy_API/api/Values/SubmitLogin"; // Your API URL
        const data = {
          UserName: email,
          Password: pass,
          Token: {
            AccessToken: "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
          },
        };
        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          });

          const result = await response.json();
          console.log(data);

          // Assuming your API returns a field 'success' for login status
            if (result && result.ID !== null && result.ID !== undefined) {
            // Do NOT store plaintext passwords in localStorage.
            localStorage.setItem("username", result.username);
            localStorage.setItem("userID", result.ID);
            localStorage.setItem("name", result.FullName);
            localStorage.setItem("isLoggedIn", "true");
            localStorage.setItem("roletype", result.Role);
            localStorage.setItem("email", email);
            await syncProfileLanguageFromGetProfile({ userId: result.ID, userName: email });

            // Navigate based on the username
            if (result.Role === "Master") {
              navigate("/mainmasters");
            } else if (result.Role === "Member") {
              navigate("/chart");
              try {
                const response = await fetch(
                  `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotal?ID=${result.ID}`
                );
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                const data = await response.json();
                localStorage.setItem("coins", data[0].COINS);
              } catch (error) {
                console.error("Error fetching coins:", error);
              }

              try {
                const response = await fetch(
                  `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotalCommission?ID=${result.ID}`
                );
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                const data = await response.json();
                localStorage.setItem("comcoins", data[0].COINS);
              } catch (error) {
                console.error("Error fetching coins:", error);
              }
              window.location.reload();
            }
          } else {
            setModalContent({
              title: "Wrong Credentials",
              message: "Username or password is incorrect.",
            });
            setIsModal(true);
            console.log(result);
          }
        } catch (error) {
          setModalContent({
            title: "Error",
            message: "An error occurred during login. Please try again.",
          });
          setIsModal(true);
          console.error("Login error:", error);
        }
      }
    } catch (error) {
      console.error("Error during Google Sign-In or API call:", error);
    }
  };

  // Add this useEffect to prevent background scrolling when the modal is open
useEffect(() => {
  if (elementFinderResult_DO_NOT_SHOW) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
  return () => {
    document.body.style.overflow = ""; // Cleanup on unmount
  };
}, [elementFinderResult_DO_NOT_SHOW]);

  const handleAppleSignIn = async () => {
    const auth = getAuth();
    const provider = new OAuthProvider("apple.com");

    try {
      const result = await signInWithPopup(auth, provider);

      // Get the signed-in user's info
      const user = result.user;
      const name = result.user.displayName;
      const email = result.user.email;
      console.log("User Info:", user);
      console.log("User:", name, email);

      // Get Apple-specific OAuth token
      const credential = OAuthProvider.credentialFromResult(result);
      const accessToken = credential.accessToken;
      const idToken = credential.idToken;
      console.log("Access Token:", accessToken);
      console.log("ID Token:", idToken);

      try {
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/Booking/getEmailAuth?email=${email}`
        );
        if (!response.ok) {
          throw new Error(`API request failed with status ${response.status}`);
        }
        const apiData = await response.json();
        setPassword(apiData[0].PASSWORD);
        // Check if account exists
        if (apiData.length === 0 || !apiData[0]?.ID) {
          alert("wont work");
        } else {
          console.log("Account found:", apiData[0]);
          const password = apiData[0]?.PASSWORD;
          const url =
            "https://xianhefairy.com/LotusFairy_API/api/Values/SubmitLogin"; // Your API URL
          const data = {
            UserName: email,
            Password: password,
            Token: {
              AccessToken:
                "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
            },
          };
          try {
            const response = await fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            });

            const result = await response.json();
            console.log(data);

            // Assuming your API returns a field 'success' for login status
            if (result && result.ID !== null && result.ID !== undefined) {
              // Do NOT store plaintext passwords in localStorage.
              localStorage.setItem("username", result.username);
              localStorage.setItem("userID", result.ID);
              localStorage.setItem("name", result.FullName);
              localStorage.setItem("isLoggedIn", "true");
              localStorage.setItem("roletype", result.Role);
              localStorage.setItem("email", email);
              await syncProfileLanguageFromGetProfile({ userId: result.ID, userName: email });

              // Navigate based on the username
              if (result.Role === "Master") {
                navigate("/mainmasters");
              } else if (result.Role === "Member") {
                navigate("/chart");
                try {
                  const response = await fetch(
                    `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotal?ID=${result.ID}`
                  );
                  if (!response.ok) {
                    throw new Error("Network response was not ok");
                  }
                  const data = await response.json();
                  localStorage.setItem("coins", data[0].COINS);
                } catch (error) {
                  console.error("Error fetching coins:", error);
                }

                try {
                  const response = await fetch(
                    `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotalCommission?ID=${result.ID}`
                  );
                  if (!response.ok) {
                    throw new Error("Network response was not ok");
                  }
                  const data = await response.json();
                  localStorage.setItem("comcoins", data[0].COINS);
                } catch (error) {
                  console.error("Error fetching coins:", error);
                }
                window.location.reload();
              }
            } else {
              setModalContent({
                title: "Wrong Credentials",
                message: "Username or password is incorrect.",
              });
              setIsModal(true);
              console.log(result);
            }
          } catch (error) {
            setModalContent({
              title: "Error",
              message: "An error occurred during login. Please try again.",
            });
            setIsModal(true);
            console.error("Login error:", error);
          }
        }
      } catch (error) {
        console.error("Error during Google Sign-In or API call:", error);
      }
    } catch (error) {
      console.error("Error signing in with Apple:", error);
      if (error.code === "auth/cancelled-popup-request") {
        alert("Sign-in process was cancelled. Try again.");
      }
    }
  };

  // Redirect to HTTPS in production (skip localhost/dev).
  useEffect(() => {
    try {
      if (
        typeof window !== "undefined" &&
        window.location &&
        window.location.protocol === "http:" &&
        !/localhost|127\.0\.0\.1/.test(window.location.hostname)
      ) {
        window.location.replace(window.location.href.replace(/^http:/, "https:"));
      }
    } catch (e) {
      // silent fallback
    }
  }, []);

  const onClick = async () => {
    if (!username || !password) {
      setModalContent({
        title: "Missing Credentials",
        message: "Please enter credentials.",
      });
      setIsModal(true);
      return;
    }

    const url = "https://xianhefairy.com/LotusFairy_API/api/Values/SubmitLogin";
    const data = {
      UserName: username,
      Password: password,
      Token: {
        AccessToken: "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
      },
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (result && result.ID !== null && result.ID !== undefined) {
        // Do NOT store plaintext passwords in localStorage.
        localStorage.setItem("username", username);
        localStorage.setItem("userID", result.ID);
        localStorage.setItem("name", result.FullName);
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("roletype", result.Role);
        await syncProfileLanguageFromGetProfile({ userId: result.ID, userName: username });
        
        // Preserve language preference
        const currentLanguage = localStorage.getItem('language') || 'en';
        localStorage.setItem('language', currentLanguage);

        // Navigate based on the username
        if (result.Role === "Master") {
          navigate("/mainmasters");
        } else if (result.Role === "Member") {
          navigate("/chart");
          try {
            const response = await fetch(
              `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotal?ID=${result.ID}`
            );
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            const data = await response.json();
            localStorage.setItem("coins", data[0].COINS);
          } catch (error) {
            console.error("Error fetching coins:", error);
          }

          try {
            const response = await fetch(
              `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotalCommission?ID=${result.ID}`
            );
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            const data = await response.json();
            localStorage.setItem("comcoins", data[0].COINS);
          } catch (error) {
            console.error("Error fetching coins:", error);
          }
          window.location.reload();
        }
      } else {
        alert("Email or Password is incorrect");
      }
    } catch (error) {
      setModalContent({
        title: "Error",
        message: "An error occurred during login. Please try again.",
      });
      setIsModal(true);
      console.error("Login error:", error);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Open modal if user is logged in
    if (isLoggedIn) {
      setIsModalOpen(true);
    }
  }, [isLoggedIn]); // Runs when isLoggedIn changes

  //Forgot Password
  const [step, setStep] = useState(0); // 1: enter email, 2: verify code, 3: new password
  const [email, setEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState();
  const [enteredCode, setEnteredCode] = useState("");
  const [newPass, setNewPass] = useState("");
  const [reNewPass, setReNewPass] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleSendEmail = async () => {
    try {
      const res = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/email/send_reset",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ToEmail: email,
            CreatedBy: email,
          }),
        }
      );
      const result = await res.json();
      if (result) {
        setVerificationCode(result.sentCode); // You might not get the code directly in production
        setErrorMsg("");
        setStep(2);
        console.log(result);
      } else {
        setErrorMsg(result?.Message || "Failed to send reset code.");
        console.log(result);
      }
    } catch (err) {
      console.error(err);
      setErrorMsg("Error sending reset email.");
    }
  };

  const handleVerifyCode = () => {
    if (enteredCode == verificationCode) {
      setErrorMsg("");
      setStep(3);
    } else {
      setErrorMsg("Invalid verification code.");
    }
  };

  const handleChangePassword = async () => {
    console.log("Attempting to update password...");
    // Validate password complexity: min 6 chars, 1 upper, 1 lower, 1 number, 1 special
    const pwdRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\[\]{};':"\\|,.<>\/?`~\-]).{6,}$/;
    if (!pwdRegex.test(newPass)) {
      setErrorMsg(t('signUpPage.passwordRequirements') || 'Password must be at least 6 characters and include uppercase, lowercase, number and special character.');
      return;
    }
    if (newPass !== reNewPass) {
      console.log("Passwords do not match.");
      setErrorMsg(t('loginPage.passwordNotMatch') || "Passwords do not match.");
      return;
    }

    try {
      console.log("Sending password reset request for:", email);
      const res = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/booking/ResetPassword",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Username: email, NewPassword: newPass }),
        }
      );
      const result = await res.json();
      console.log("Password reset response:", result);

      if (res.ok && result?.Success === true) {
        console.log("Password reset successful.");
        setStep(0); // This closes the modal
        setIsModalOpen(false);
        setEmail("");
        setNewPass("");
        setReNewPass("");
        setEnteredCode("");
        setErrorMsg("");
        setSuccessMsg("Password reset successfully.");
        setTimeout(() => {
          window.location.reload();
        }, 2000); // Reload after 2 seconds
      } else {
        console.log("Password reset failed:", result?.Message || "Failed to update password.");
        setErrorMsg(result?.Message || "Failed to update password.");
      }
    } catch (error) {
      console.error("Error updating password:", error);
      setErrorMsg("Error updating password.");
    }
  };

  return (
    <div className="he-landing">
      {/* Header with TopBar */}
      <header className="he-header">
        <TopBar
          cartCount={cartItemCount}
          isLoggedIn={isLoggedIn}
          onCartClick={() => navigate('/cart')}
          onMySpaceClick={handleDropdownToggle}
          onSignInClick={toggleLoginPanel}
          coins={coins}
          onLogout={handleLogout}
        />
      </header>

      {/* Profile dropdown — position:fixed, renders above all content */}
      {isLoggedIn && (
        <div ref={dropdownRef}>
          <div style={dropdownStyle} role="menu" aria-hidden={!isDropdownVisible}>
            <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '10px', marginLeft: '5px' }}>
              <div style={{ backgroundColor: "black", border: "1px solid #ddd", borderRadius: "5px", padding: "8px 12px", margin: "0 5px", textAlign: "center", fontSize: "16px", fontWeight: "bold", flex: "1", justifyContent: "center", alignContent: "center", flexDirection: "row", height: "50px" }}>
                <img src={coinsImg} alt="Gems" style={{ height: "50%" }} />{" "}
                {coins} {t('tryoutpage.gems')}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', marginTop: '15px', alignItems: 'stretch', justifyContent: 'space-between', flexWrap: 'nowrap', overflowX: 'auto' }}>
              <button style={{ backgroundColor: "black", border: "1px solid #dcdcdc", padding: "5px 12px", borderRadius: "5px", cursor: "pointer", color: "#DFBD69", fontSize: "14px", flex: 1, whiteSpace: "nowrap", textAlign: "center" }} onClick={() => navigate('/account')}>
                {t('tryoutpage.account')}
              </button>
              <Link to="/purchasehistory" style={{ backgroundColor: "black", border: "1px solid #dcdcdc", padding: "5px 12px", borderRadius: "5px", cursor: "pointer", color: "#DFBD69", fontSize: "14px", textDecoration: "none", flex: 1, whiteSpace: "nowrap", textAlign: "center" }}>
                {t('tryoutpage.history')}
              </Link>
              <button style={{ backgroundColor: "black", border: "1px solid #dcdcdc", padding: "5px 12px", borderRadius: "5px", cursor: "pointer", color: "#DFBD69", fontSize: "14px", flex: 1, whiteSpace: "nowrap", textAlign: "center" }} onClick={handleLogout}>
                {t('tryoutpage.logout')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Login panel — slides in from the right */}
      {isLoginPanelOpen && (
        <>
          <div style={{ position: "fixed", top: 0, right: 0, width: isMobile ? "100vw" : "30vw", height: "100%", backgroundColor: "black", boxShadow: "0 0 10px rgba(0,0,0,0.5)", zIndex: 10000 }}>
            <Login onClose={toggleLoginPanel} />
          </div>
          <div onClick={toggleLoginPanel} style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: isMobile ? "black" : "rgba(0,0,0,0.5)", zIndex: 9999 }} />
        </>
      )}

      {showCollectAmuletLoginModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.65)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 12000,
            padding: "20px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "460px",
              background: "radial-gradient(circle, rgba(28, 18, 52, 0.96) 0%, rgba(9, 9, 18, 0.96) 100%)",
              border: "1px solid rgba(223, 189, 105, 0.85)",
              borderRadius: "14px",
              padding: isMobile ? "20px" : "26px",
              boxShadow: "0 20px 50px rgba(0, 0, 0, 0.45)",
              color: "#F8F5FE",
              textAlign: "center",
            }}
          >
            <h3
              style={{
                margin: 0,
                marginBottom: "10px",
                color: "#DFBD69",
                fontFamily: '"PlayfairDisplay", serif',
                fontSize: isMobile ? "1.3rem" : "1.5rem",
              }}
            >
              {t("mainPage.loginRequiredForAmulet", "Login Required")}
            </h3>
            <p
              style={{
                margin: 0,
                marginBottom: "22px",
                lineHeight: 1.6,
                fontSize: isMobile ? "0.95rem" : "1rem",
                color: "rgba(248, 245, 254, 0.92)",
              }}
            >
              {t(
                "mainPage.loginSignupBeforeCollecting",
                "You need to login or sign up first before collecting your amulet."
              )}
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: "10px",
                justifyContent: "center",
              }}
            >
              <button
                onClick={() => {
                  setShowCollectAmuletLoginModal(false);
                  if (!isLoginPanelOpen) {
                    setIsLoginPanelOpen(true);
                  }
                }}
                style={{
                  minHeight: "44px",
                  padding: "10px 20px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(to right, #DFBD69, #B9954D)",
                  color: "#150A2A",
                  fontWeight: 700,
                  cursor: "pointer",
                }}
              >
                {t("mainPage.login", "Login")}
              </button>
              <button
                onClick={() => {
                  setShowCollectAmuletLoginModal(false);
                  navigate("/signup");
                }}
                style={{
                  minHeight: "44px",
                  padding: "10px 20px",
                  borderRadius: "10px",
                  border: "1px solid rgba(223, 189, 105, 0.85)",
                  background: "transparent",
                  color: "#DFBD69",
                  fontWeight: 700,
                  cursor: "pointer",
                }}
              >
                {t("mainPage.signup", "Sign Up")}
              </button>
              <button
                onClick={() => setShowCollectAmuletLoginModal(false)}
                style={{
                  minHeight: "44px",
                  padding: "10px 20px",
                  borderRadius: "10px",
                  border: "1px solid rgba(248, 245, 254, 0.25)",
                  background: "transparent",
                  color: "#F8F5FE",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                {t("mainPage.close", "Close")}
              </button>
            </div>
          </div>
        </div>
      )}

      <main>
        <section className="he-hero" id="home" ref={heroRef}>
          <div className="he-hero-art" aria-hidden="true">
            <img className="he-hero-sky" src={heroSky} alt="" />
            <img className="he-hero-sky he-drift-left" src={heroSky} alt="" />
            <img className="he-hero-sky he-drift-right" src={heroSky} alt="" />
          </div>
          <div className="he-hero-title">
            <h1><em>Hé</em> · {t('mainPage.hereToHear', 'HERE TO HEAR')}</h1>
            <p>
              <span>{t('mainPage.heroTagline', 'Find your way, one conversation at a time')}</span>{' '}
              <span>{t('mainPage.heroSubtitle', 'A space to talk, reflect & find clarity — inspired by Master SiewLi’s wisdom.')}</span>
            </p>
          </div>
          <div className="he-hero-action">
            <div className="he-birth" role="group" aria-label={t('mainPage.dateOfBirth', 'Date of birth')}>
              <select
                aria-label={t('mainPage.birthMonth', 'Birth month')}
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
              >
                {months.map((m, i) => (
                  <option key={m} value={String(i + 1)}>{m}</option>
                ))}
              </select>
              <select
                aria-label={t('mainPage.birthDay', 'Birth day')}
                value={selectedDay}
                onChange={(e) => setSelectedDay(e.target.value)}
              >
                {days.map((d) => (
                  <option key={d} value={d}>{d}</option>
                ))}
              </select>
              <select
                aria-label={t('mainPage.birthYear', 'Birth year')}
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                {years.map((y) => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </div>
            <button
              type="button"
              className="he-gold"
              onClick={handleLetsTalk}
            >
              {t('mainPage.letsTalk', 'LET’S TALK')}
            </button>
          </div>
          <a className="he-discover" href="#our-services">
            {t('mainPage.discoverMore', 'DISCOVER MORE')}
            <span aria-hidden="true">↓</span>
          </a>
        </section>

        <OurServices />

        <section className="he-section he-amu" id="amu">
          <img className="he-section-bg" src={amuBg} alt="" />
          <div className="he-intro">
            <div className="he-eyebrow">A-MU</div>
            <h2><em>Hé</em> A-MU</h2>
            <p>{amuSectionDescriptionLine1}</p>
          </div>
          <div
            className="he-carousel"
            role="region"
            aria-roledescription="carousel"
            aria-label="A-MU"
            onPointerEnter={(e) => e.pointerType === "mouse" && setIsAmuletPaused(true)}
            onPointerLeave={(e) => e.pointerType === "mouse" && setIsAmuletPaused(false)}
            onFocus={(e) => e.target.matches(":focus-visible") && setIsAmuletPaused(true)}
            onBlur={() => setIsAmuletPaused(false)}
            onTouchStart={(e) => { amuletTouchX.current = e.touches[0].clientX; }}
            onTouchEnd={(e) => {
              if (amuletTouchX.current === null) return;
              const dx = e.changedTouches[0].clientX - amuletTouchX.current;
              amuletTouchX.current = null;
              if (Math.abs(dx) > 40) stepAmulet(dx < 0 ? 1 : -1);
            }}
          >
            {amuletSlides.map((slide, index) => {
              const slot = getAmuletSlot(index);
              const isVisible = !slot.startsWith("hidden");
              return (
                <button
                  type="button"
                  key={slide.key}
                  className={`he-amu-card he-slot-${slot}`}
                  onClick={() => setActiveAmulet(index)}
                  tabIndex={isVisible ? 0 : -1}
                  aria-hidden={!isVisible}
                  aria-label={slide.name}
                  aria-current={slot === "center" || undefined}
                >
                  <img src={slide.image} alt="" draggable="false" />
                  {slide.free && slot === "center" && (
                    <span className="he-amu-free">{t('mainPage.free', 'FREE').toUpperCase()}</span>
                  )}
                </button>
              );
            })}
          </div>
          <p className="he-amu-copy">{t('mainPage.yourdailyamuletdesc')}</p>
          <div className="he-amu-actions">
            <button type="button" className="he-outline" onClick={handleCollectAmuletClick}>
              {isLoggedIn ? t('mainPage.collectyouramulet') : t('mainPage.yourdailyamuletbutton')}
              <img src={arrowRight} alt="" width="14" height="8" />
            </button>
          </div>
        </section>

        <section className="he-section he-about" id="about">
          <img className="he-section-bg" src={aboutBg} alt="" />
          <div className="he-intro">
            <div className="he-eyebrow">{rootsSectionSubheading || t('mainPage.builtForSeekers', 'Built for Seekers')}</div>
            <h2>{rootsSectionTitle}</h2>
            {rootsSectionParagraphs.map((text) => (
              <p key={text}>{text}</p>
            ))}
          </div>
          <video
            className="he-film"
            src={introVideo}
            poster={filmPoster}
            controls
            playsInline
            preload="none"
          />
          <div className="he-banner" aria-hidden="true">
            <img src={aboutBanner} alt="" />
          </div>
        </section>
      </main>

      {elementFinderResult && createPortal(
        <div 
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 20000,
            padding: isMobile ? "5px" : "20px",
            backgroundColor: "rgba(0,0,0,0.78)",
            backdropFilter: "blur(6px)",
            WebkitBackdropFilter: "blur(6px)",
          }}
          onClick={() => {
            setElementFinderResult(null);
            setShowZodiacTooltip(false); // Reset read more button
          }}
        >
          <div 
            style={{
              background: "radial-gradient(120% 120% at 50% 0%, rgba(34, 23, 72, 0.92) 0%, rgba(18, 12, 40, 0.96) 56%, #0d0b24 100%) padding-box, linear-gradient(90deg, #C9A84B, #8A5DF4) border-box",
              borderRadius: "16px",
              padding: "2rem",
              maxWidth: isMobile ? "95vw" : "800px",
              maxHeight: isMobile ? "95vh" : "70vh",
              width: "100%",
              color: "#FFCB21",
              position: "relative",
              overflow: "auto",
              border: "1px solid transparent",
              boxShadow: "0 18px 46px rgba(0,0,0,0.55)",
              zIndex: 16001,
            }}
            onClick={e => e.stopPropagation()} // Prevent closing when clicking inside modal
          >
            {/* <button
              onClick={() => setElementFinderResult(null)}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                background: "#FFCB21",
                color: "#000",
                border: "none",
                borderRadius: "50%",
                width: "35px",
                height: "35px",
                fontSize: "18px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
              }}
            >
              ×
            </button> */}

            <div style={{ textAlign: "center", paddingTop: "10px" }}>
              <h2 style={{
                color: "#DEAF77",
                margin: "0 0 1.5rem 0",
                fontSize: isMobile ? "1.4rem" : "2.2rem",
                fontWeight: "bold",
                textShadow: "0 0 14px rgba(222, 175, 119, 0.3)"
              }}>
                {t('mainPage.YourElement')}: {elementFinderResult.title}
              </h2>

              {/* Move image to the top above About Your Element */}
              <img
                src={elementFinderResult.image}
                alt={elementFinderResult.title}
                style={{
                  width: isMobile ? "75px" : "150px",
                  height: isMobile ? "75px" : "150px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "2px solid #DFBD69",
                  boxShadow: "0 0 0 4px rgba(223,189,105,0.16), 0 10px 20px rgba(0,0,0,0.35)",
                  marginBottom: "1.5rem"
                }}
              />

              <div style={{
                flex: 1,
                textAlign: "left",
                minWidth: 0,
                margin: "0 auto",
                maxWidth: isMobile ? "95vw" : "600px"
              }}>
                {/* API Stem Description or fallback to summary */}
                <div style={{
                  border: "1px solid rgba(223, 189, 105, 0.35)",
                  background: "linear-gradient(180deg, rgba(40, 27, 90, 0.4), rgba(19, 13, 43, 0.72))",
                  borderRadius: "10px",
                  padding: "1rem",
                  marginBottom: "1rem",
                }}>
                  <h3 style={{
                    color: "#FFCB21",
                    margin: "0 0 0.5rem 0",
                    fontSize: isMobile ? "1rem" : "1.3rem",
                    fontWeight: "bold",
                    textAlign: "center"
                  }}>
                    {t('mainPage.aboutYourElement')}
                  </h3>
                  <div
                    className="element-modal-content"
                    style={{
                      color: "#FFF6D7",
                      fontSize: isMobile ? "0.95rem" : "1.05rem",
                      margin: "0",
                      lineHeight: "1.5",
                      whiteSpace: "pre-wrap",
                      textAlign: "center"
                    }}
                    dangerouslySetInnerHTML={{
                      __html: elementFinderResult.apiStemDescription || elementFinderResult.summary
                    }}
                  />
                </div>
              </div>

              {/* Zodiac info and API Zodiac Description */}
              {(zodiacName || zodiacSign) && (
                <div style={{
                  border: "1px solid rgba(223, 189, 105, 0.35)",
                  background: "linear-gradient(180deg, rgba(40, 27, 90, 0.3), rgba(19, 13, 43, 0.62))",
                  borderRadius: "12px",
                  padding: "1rem",
                  marginBottom: "1.5rem"
                }}>
                  <h3 style={{
                    color: "#FFCB21",
                    margin: "0 0 1rem 0",
                    fontSize: isMobile ? "1rem" : "1.4rem"
                  }}>
                    {t('mainPage.zodiacInsight')}
                  </h3>
                  <div style={{
                    color: "#FFF6D7",
                    fontSize: isMobile ? "1.05rem" : "1.15rem",
                    margin: "0",
                    fontWeight: "bold"
                  }}>
                    {zodiacName} {zodiacSign}
                  </div>
                  {/* Read more link and description */}
                  {showZodiacTooltip ? null : (
                    <span
                      style={{
                        color: "#FFCB21",
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontSize: isMobile ? "0.95rem" : "1.05rem",
                        marginTop: "0.5rem",
                        display: "inline-block"
                      }}
                      onClick={() => setShowZodiacTooltip(true)}
                    >
                      {t('mainPage.readMore')}
                    </span>
                  )}
                  {showZodiacTooltip && (
                    <div>
                      {/* Show zodiac image only when tooltip is open */}
                      {(() => {
                        const matchedZodiac = zodiacMappings.find(
                          z => z.stem.toLowerCase() === (zodiacName || "").toLowerCase()
                        );
                        if (matchedZodiac && matchedZodiac.image) {
                          return (
                            <img
                              src={matchedZodiac.image}
                              alt={matchedZodiac.title}
                              style={{
                                width: isMobile ? "60px" : "130px",
                                height: isMobile ? "60px" : "130px",
                                borderRadius: "50%",
                                objectFit: "cover",
                                margin: "12px auto",
                                display: "block",
                                border: "2px solid rgba(223, 189, 105, 0.7)",
                                boxShadow: "0 0 0 4px rgba(223,189,105,0.14), 0 12px 22px rgba(0,0,0,0.3)"
                              }}
                            />
                          );
                        }
                        return null;
                      })()}
                      <div
                        className="element-modal-content"
                        style={{
                          color: "#FFF6D7",
                          fontSize: isMobile ? "0.95rem" : "1.05rem",
                          marginTop: "0.5rem",
                          fontStyle: "italic",
                          whiteSpace: "pre-wrap",
                          lineHeight: "1.5"
                        }}
                        dangerouslySetInnerHTML={{
                          __html: elementFinderResult.apiZodiacDescription ||
                            zodiacDescriptions[
                              (zodiacName.charAt(0).toUpperCase() + zodiacName.slice(1).toLowerCase())
                            ]
                        }}
                      />
                    </div>
                  )}
                  {/* Add the requested text above the action buttons */}
                  <div style={{
                    width: "100%",
                    textAlign: "center",
                    color: "#FFF6D7",
                    fontSize: isMobile ? "1rem" : "1.2rem",
                    fontWeight: "bold",
                    margin: "2rem 0 1.2rem 0",
                    lineHeight: "1.5"
                  }}>
                    {t('mainPage.startPlanningLife')}<br />
                    {t('mainPage.yourDestinyForecast')}<br />
                    {t('mainPage.yourLuckActivators')}<br />
                    {t('mainPage.yourBlessedAmulets')}
                  </div>
                  {/* Action buttons */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: isMobile ? "column" : "row",
                      gap: "1rem",
                      justifyContent: "center",
                      alignItems: isMobile ? "center" : "flex-start", // Center buttons on mobile
                      width: "100%",
                    }}
                  >
                    <button
                      className="find-destiny-btn glow-on glow-text"
                      style={{
                        padding: "12px 26px",
                        background: "linear-gradient(#1B0E3C, #1B0E3C) padding-box, linear-gradient(90deg, #C9A84B, #8A5DF4) border-box",
                        color: "#FFFFFF",
                        border: "1px solid transparent",
                        borderRadius: "30px",
                        fontSize: isMobile ? "1rem" : "1.1rem",
                        cursor: "pointer",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.32)",
                        fontWeight: "bold",
                        marginBottom: isMobile ? "10px" : "0",
                        width: isMobile ? "80%" : "35%", // Wider on mobile
                        textAlign: "center",
                        display: "block",
                      }}
                      onClick={() => navigate("/signup")}
                    >
                      {t('mainPage.startFreeNow')}
                    </button>
                    <button
                      onClick={() => {
                        setElementFinderResult(null);
                        setShowZodiacTooltip(false); // Reset read more button
                      }}
                      style={{
                        padding: "12px 24px",
                        background: "transparent",
                        color: "#DFBD69",
                        border: "1px solid rgba(223, 189, 105, 0.75)",
                        borderRadius: "30px",
                        fontSize: isMobile ? "1rem" : "1.1rem",
                        cursor: "pointer",
                        fontWeight: "bold",
                        width: isMobile ? "80%" : "35%", // Wider on mobile
                        textAlign: "center",
                        display: "block",
                        transition: "all 0.3s ease"
                      }}
                    >
                      {t('mainPage.close')}
                    </button>
                  </div>
                </div>
              )}

              {/* Action buttons */}
              {/* <div style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: "1rem",
                justifyContent: "center"
              }}> */}
                {/* Add the requested text before the action buttons */}
                {/* <div style={{
                  width: "100%",
                  textAlign: "center",
                  color: "#FFF6D7",
                  fontSize: isMobile ? "1rem" : "1.2rem",
                  fontWeight: "bold",
                  marginBottom: "1.2rem",
                  lineHeight: "1.5"
                }}>
                  Start planning a better life with…<br />
                  Your Destiny Forecast<br />
                  Your Luck Activators<br />
                  Your Blessed Amulets
                </div>
                <button
                  className="find-destiny-btn glow-on glow-text"
                  style={{
                    padding: "12px 26px",
                    background: "black",
                    color: "#FFCB21",
                    border: "2px solid #FFCB21",
                    borderRadius: "30px",
                    fontSize: isMobile ? "16px" : "18px",
                    cursor: "pointer",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                    fontWeight: "bold",
                    marginBottom: isMobile ? "10px" : "0",
                    width: "100%",
                    textAlign: "center",
                  }}
                  onClick={() => navigate("/signup")}
                >
                  Start FREE now
                </button>
                <button
                  onClick={() => {
                    setElementFinderResult(null);
                    setShowZodiacTooltip(false); // Reset read more button
                  }}
                  style={{
                    padding: "12px 24px",
                    background: "transparent",
                    color: "#FFCB21",
                    border: "2px solid #FFCB21",
                    borderRadius: "8px",
                    fontSize: isMobile ? "1rem" : "1.1rem",
                    cursor: "pointer",
                    fontWeight: "bold",
                    transition: "all 0.3s ease"
                  }}
                >
                  Close
                </button>
              </div> */}
            </div>
          </div>
        </div>,
        document.body
      )}

      <ChatLoginPrompt open={showChatLoginPrompt} onClose={() => setShowChatLoginPrompt(false)} />

      <Footer />
    </div>
  );
}

export default MainPage;
